export default __webpack_public_path__ + "static/media/eye.5864f6c0.svg";